module.exports = __webpack_public_path__ + "img/aid.c1b7cd96.png";